import './index.scss';
import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { useState } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../../shared/action-creator/alert-messages';
// import FileUploadPanel from '../../../mass-update/components/file-upload-panel';
import { ModalBase } from '../../../shared/components/modals/modal-base';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { customizeErrorAlert } from '../../../shared/services/customize-error-alert-bar';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';
import { uploadFunctionCodeMaintenance } from '../../repositories';
import _ from "lodash";
import FileUploadPanelWorklist from '../../../workList/components/file-upload-panel-worklist';
//import FileUploadPanel from '../../../mass-update/components/file-upload-panel';

function FunctionCodeMultipleEntryPopup ( props ) {

    const [fileInfo, setFileInfo] = useState( {} );
    const [uploadResponse, setUploadResponse] = useState( {} );
    const [showLoader, setShowLoader] = useState( false );
    const handleFileDrop = files => {

        setFileInfo( files[0] );

    };

    const handleRejectedFiles = () => {

        const msg = 'Only CSV files are allowed';
        customizeErrorAlert( msg );

    };
    const onCancel = () => {
        setFileInfo( { } );
        setUploadResponse({ } );
        props.onClose();

    };

    // const handleSubmitClick = () => {
    //     console.log("HANDLE SUBMIT")
    //     // props.increaseCounter();
    //     setShowLoader(true)
    //     worklistRefineUpload( fileInfo ).then( response => {
    //         setUploadResponse(response)
    //         // customizeErrorAlert( response.status );
    //         if ( response.errors.length ) {
    //             response.errors.forEach( element => {
    //                 customizeErrorAlert( element );
    //             } );

    //         } else{
    //             // props.createSuccessMessage( response.status );
    //             props.decreaseCounter();
    //             setShowLoader(false)
    //         }

    //     } ).catch( () => {
    //         props.decreaseCounter();
    //         setShowLoader(false)
    //     } );
    //     // onCancel();
    // };

    // const handleCancelClick = () => {
    //     setFileInfo( { } );
    //     setUploadResponse({ } );
    // };

    const handleSubmitClick = () => {

      //  props.increaseCounter();
      setShowLoader(true)
        uploadFunctionCodeMaintenance( fileInfo ).then( response => {
         console.log("response$$$ ",response);
            // customizeErrorAlert( response.status );
            if ( response.errors.length ) {
                response.errors.forEach( element => {
                    customizeErrorAlert( element );
                    props.decreaseCounter();
                    setShowLoader(false)
                } );

            } else{
                // props.createSuccessMessage( response.status );
                setUploadResponse(response)
                props.decreaseCounter();
                setShowLoader(false)
            }

        } ).catch( () => {

            props.decreaseCounter();
            setShowLoader(false)

        } );
      //  onCancel();

    };

    const handleCancelClick = () => {

        setFileInfo( { } );

    };

    // const responses = {
    //     'FUNCTION_CD': '2',
    //     'DESIGN_TEAM_CD': '2',
    //     'CORRECT_PART_NUM': '2',
    //     "UNIT-FUNCTION-CODE-EPH": 0,
    //     "WORKLIST REFINE / REMOVE": "0 / 0"
    // }

    const loaderStyleLoader = {
        width: '15%',
        display: 'inline-block',
        marginTop:'10px',
        zIndex: '1'
    };
    const loaderStyleContent = {
        width: '30%',
        display: 'inline-block',
        textAlign:'center',
        // paddingBottom:'10px'
    };

    const containerStyle = {
        // marginTop: '1%',
        backgroundColor: 'white',
        border: '1px solid black',
        borderStyle: 'dotted',
        borderRadius: '4px',
        paddingLeft: '10px',
        marginLeft: '5px',
        marginRight: '5px',
        fontSize: '14px'
    };


    // const uploadStatus = "TOTAL UPDATED : 100 Out-Off 130 Records."
    const valueStyleStart = {
        width: '5%',
        display: 'inline-block'
    };
    const valueStyleLeft = {
        width: '50%',
        display: 'inline-block',
        fontSize: '12px',
    };
    const valueStyleMiddle = {
        width: '5%',
        display: 'inline-block',
        fontSize: '12px',
        fontWeight:'bold'
    };
    const valueStyleRight = {
        width: '30%',
        display: 'inline-block',
        fontSize: '12px'
    };

    // const valueStyleLeftListHeading = {
    //     width: '90%',
    //     display: 'inline-block',
    //     fontSize: '12px',
    //     fontWeight:'bold'
    //
    // };
    // const valueStyleLeftListContent = {
    //     width: '25%',
    //     display: 'inline-block',
    //     fontSize: '12px',
    // };
    // const valueStyleLeftListContentPP = {
    //     width: '20%',
    //     display: 'inline-block',
    //     fontSize: '12px',
    // };

    return (

        <ModalBase
            body={(
                <div className="file-upload-panel">
                    <div className="upload-area">
                        <FileUploadPanelWorklist
                            uploadLabel="Function Code Maintenance Upload"
                            handleFileDrop={handleFileDrop}
                            handleRejectedFiles={handleRejectedFiles}
                            handleSubmitClick={handleSubmitClick}
                            handleCancleClick={handleCancelClick}
                            fileName={fileInfo.name}
                        />
                    </div>
                    {
                        (showLoader) ?
                        <div>
                            <li style={loaderStyleContent}>Please Wait..</li>
                            <li style={loaderStyleLoader}>
                                <div className="loader"></div>
                            </li>
                        </div> : null
                    }




                    {/*<div style={containerStyle}>*/}
                    {/*    <b>{uploadStatus} &#9989; </b>*/}
                    {/*    <hr></hr>*/}
                    {/*        {*/}
                    {/*            Object.entries(responses).map( ([key, value]) =>*/}
                    {/*            <small>*/}
                    {/*                <ul>*/}
                    {/*                    <li style={valueStyleStart}>&#10004;</li>*/}
                    {/*                    <li style={valueStyleLeft}>{key}</li>*/}
                    {/*                    <li style={valueStyleMiddle}>&ndash;</li>*/}
                    {/*                    <li style={valueStyleRight}>{value} Records</li>*/}
                    {/*                </ul>*/}
                    {/*            </small>*/}
                    {/*    )}*/}

                        {/*{*/}
                        {/*    (!_.isEmpty(invalidPrimePartList)) ?*/}
                        {/*        <div>*/}
                        {/*            <hr></hr>*/}
                        {/*            <ul>*/}
                        {/*                <li style={valueStyleStart}>&#9888;</li>*/}
                        {/*                <li style={valueStyleLeft}><b>INVALID PRIMEPART NUMBER</b></li>*/}
                        {/*                <li style={valueStyleMiddle}>&ndash;</li>*/}
                        {/*                <li style={valueStyleRight}>{invalidPrimePartList.length} Records</li>*/}
                        {/*                {*/}
                        {/*                    invalidPrimePartList.map((ppNumber) => (*/}
                        {/*                        <li style={valueStyleLeftListContentPP}>&bull; {ppNumber}</li>*/}
                        {/*                    ))}*/}
                        {/*            </ul>*/}

                        {/*        </div> : null*/}
                        {/*}*/}

                    {/*    {*/}
                    {/*        (!_.isEmpty(bmcNotFoundList)) ?*/}
                    {/*            <div>*/}
                    {/*                <hr></hr>*/}
                    {/*                    <ul>*/}
                    {/*                        <li style={valueStyleStart}>&#9888;</li>*/}
                    {/*                        <li style={valueStyleLeft}><b>BMC NOT FOUND</b></li>*/}
                    {/*                        <li style={valueStyleMiddle}>&ndash;</li>*/}
                    {/*                        <li style={valueStyleRight}>{bmcNotFoundList.length} Records</li>*/}
                    {/*                        {*/}
                    {/*                            bmcNotFoundList.map((claimNumber) => (*/}
                    {/*                            <li style={valueStyleLeftListContent}>&bull; {claimNumber}</li>*/}
                    {/*                        ))}*/}
                    {/*                    </ul>*/}

                    {/*            </div> : null*/}
                    {/*    }*/}
                    {/*</div>*/}

                    {
                        (!_.isEmpty(uploadResponse)) ?
                            <div style={containerStyle}>

                                <span role="img" aria-label="image">{uploadResponse.status} &#9989; </span>
                                <hr></hr>
                                {Object.entries(uploadResponse.uploadStatisticsMap).map( ([key, value]) =>
                                        <small>
                                            <ul>
                                                <li style={valueStyleStart}>&#10004;</li>
                                                <li style={valueStyleLeft}>{key}</li>
                                                <li style={valueStyleMiddle}>&ndash;</li>
                                                <li style={valueStyleRight}>{value} Records</li>
                                            </ul>
                                        </small>
                                    )}

                            </div> : null
                    }

                </div>
            )}
            header={(
                <div>
                    <i className="fa fa-times-circle-o pull-right" onClick={onCancel} aria-hidden="true" />
                </div>
            )}
            onHide={props.onHide}
            isOpen={props.isOpen}
            size=""
        />

    );

}


FunctionCodeMultipleEntryPopup.displayName = 'PopUpPanel';
FunctionCodeMultipleEntryPopup.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onHide: PropTypes.bool.isRequired,
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    createSuccessMessage: PropTypes.func.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    factoryCode: state.application.factories.factoryCode,
    factories: state.application.factories.factories,
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );
export default connect( mapStateToProps, mapDispatchToProps )(FunctionCodeMultipleEntryPopup);
